<nav [attr.aria-label]="label ?? (translations$ | async)?.label">
  <ol class="mui-breadcrumbs" @breadcrumbsList>
    <li
      *ngFor="let bc of (breadcrumbs$ | async) as breadcrumbs; let i = index; trackBy: trackByIndex" @breadcrumb
      [class]="['mui-breadcrumbs__entry', 'mui-breadcrumbs__entry-' + i]"
      [class.mui-breadcrumbs__entry--parent]="i === breadcrumbs.length - 2 && breadcrumbs.length >= 2 && bc.url !== breadcrumbs[i - 1]?.url"
      [class.mui-breadcrumbs__entry--current]="i === breadcrumbs.length - 1">
      <span class="mui-breadcrumbs__entry__divider" *ngIf="breadcrumbs.indexOf(bc) > 0">&#8250;</span>
      <ng-container *ngIf="i === 0; else nonRootBreadcrumb">
        <ng-container
          [ngTemplateOutlet]="routingOptions.useHrefForHomeLinks ? externalBreadcrumbTemplate : defaultBreadcrumbTemplate"
          [ngTemplateOutletContext]="{$implicit: bc, current: i === breadcrumbs.length - 1}"></ng-container>
      </ng-container>
      <ng-template #nonRootBreadcrumb>
        <ng-container
          [ngTemplateOutlet]="defaultBreadcrumbTemplate"
          [ngTemplateOutletContext]="{$implicit: bc, current: i === breadcrumbs.length - 1}"></ng-container>
      </ng-template>
    </li>
  </ol>
</nav>

<ng-template #defaultBreadcrumbTemplate let-bc let-current="current">
  <a
    class="mui-breadcrumbs__entry__label"
    [routerLink]="bc.url"
    [class.mui-breadcrumbs__entry--disabled]="!bc.url"
    [attr.aria-current]="current ? 'page' : null">
    <ng-container
      [ngTemplateOutlet]="labelTemplate ? labelTemplate : defaultLabelTemplate"
      [ngTemplateOutletContext]="{$implicit: (bc.label | async)}"></ng-container>
  </a>
</ng-template>

<ng-template #externalBreadcrumbTemplate let-bc let-current="current">
  <a class="mui-breadcrumbs__entry__label" [href]="bc.url" [attr.aria-current]="current ? 'page' : null">
    <ng-container
      [ngTemplateOutlet]="labelTemplate ? labelTemplate : defaultLabelTemplate"
      [ngTemplateOutletContext]="{$implicit: (bc.label | async)}"></ng-container>
  </a>
</ng-template>

<ng-template #defaultLabelTemplate let-label>
  {{ label }}
</ng-template>

